<template>
  <span :style="pillStyle">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
const FILLED = new Set(['block', 'monetize', 'track'])
const VARIANT_LABELS = {
  block: '차단',
  monetize: '수익화',
  track: '추적',
  active: '활성',
  inactive: '비활성',
  disputed: '이의제기',
  appealed: '항소',
  takedown: '게시중단',
  pending: '대기',
  activated: '활성',
  deactivated: '비활성',
}

const FILLED_BG = {
  block: '#d04444',
  monetize: '#1f9d55',
  track: '#7367F0',
}

const OUTLINED_COLOR = {
  active: '#1f9d55',
  activated: '#1f9d55',
  inactive: 'rgba(0,0,0,0.65)',
  deactivated: 'rgba(0,0,0,0.65)',
  disputed: '#c97a1a',
  appealed: '#c97a1a',
  pending: '#c97a1a',
  takedown: '#d04444',
}

const OUTLINED_BORDER = {
  active: 'rgba(31,157,85,0.5)',
  activated: 'rgba(31,157,85,0.5)',
  inactive: 'rgba(0,0,0,0.22)',
  deactivated: 'rgba(0,0,0,0.22)',
  disputed: 'rgba(201,122,26,0.5)',
  appealed: 'rgba(201,122,26,0.5)',
  pending: 'rgba(201,122,26,0.5)',
  takedown: 'rgba(208,68,68,0.5)',
}

const OUTLINED_BG = {
  active: 'rgba(31,157,85,0.08)',
  activated: 'rgba(31,157,85,0.08)',
  inactive: 'rgba(0,0,0,0.04)',
  deactivated: 'rgba(0,0,0,0.04)',
  disputed: 'rgba(255,159,67,0.1)',
  appealed: 'rgba(255,159,67,0.1)',
  pending: 'rgba(255,159,67,0.1)',
  takedown: 'rgba(208,68,68,0.08)',
}

export default {
  name: 'StatusPill',
  props: {
    variant: {
      type: String,
      required: true,
      validator(v) {
        return Object.prototype.hasOwnProperty.call(VARIANT_LABELS, v)
      },
    },
  },
  computed: {
    filled() {
      return FILLED.has(this.variant)
    },
    label() {
      return VARIANT_LABELS[this.variant] || this.variant
    },
    pillStyle() {
      const base = {
        display: 'inline-flex',
        alignItems: 'center',
        height: '20px',
        padding: '0 8px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.02em',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        border: '1px solid transparent',
      }
      if (this.filled) {
        return {
          ...base,
          background: FILLED_BG[this.variant],
          color: '#fff',
        }
      }
      return {
        ...base,
        color: OUTLINED_COLOR[this.variant] || 'rgba(0,0,0,0.65)',
        borderColor: OUTLINED_BORDER[this.variant] || 'rgba(0,0,0,0.22)',
        background: OUTLINED_BG[this.variant] || 'rgba(0,0,0,0.04)',
      }
    },
  },
}
</script>
